import React from "react";
import { variantForProduct } from "@/lib/variants";
import "@/product-pouch.css";
export default function ProductVisual({ product = {}, className = "" }) {
 const variant = variantForProduct(product);
 return <figure className={`lenis-product-visual ${className}`}>
  <img src={variant.artwork} alt={`LENIS ${variant.name}, product display`} width={variant.artworkWidth} height={variant.artworkHeight} />
 </figure>;
}

